import React from 'react';
import { useParams } from 'react-router-dom';
import { getCanarinPublic } from '../api/client';
import PublicCard from '../components/PublicCard';

export default function PublicPage() {
  const { username = '' } = useParams();
  const [data, setData] = React.useState(null);
  const [status, setStatus] = React.useState({ loading: true, error: null });

  React.useEffect(() => {
    let mounted = true;
    setStatus({ loading: true, error: null });
    getCanarinPublic(username)
      .then((res) => {
        const payload = res?.data || res; 
        if (mounted) {
          setData(payload);
          setStatus({ loading: false, error: null });
          const handle = payload?.profile?.username || username || 'canarin';
          document.title = `${handle} | canarin`;
        }
      })
      .catch((err) => {
        if (mounted) setStatus({ loading: false, error: err?.message || 'erro' });
      });  
    return () => { mounted = false; };
  }, [username]);

  if (status.loading) {
    return <div style={{ padding: 40, color: '#999', textAlign: 'center' }}>carregando…</div>;
  }
  if (status.error || !data) {
    return <div style={{ padding: 40, color: 'tomato', textAlign: 'center' }}>não encontrado</div>;
  }
  return <PublicCard data={data} />;
}
